import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import {
	FieldTypeEnum, LastActiveTypeModel, MenuPermissionActionEnum, RiderVehicleType, VehicleModel, ServiceTypeEnum, RiderVehicleTypeEnum
} from 'app/models';
import { OperatorVehicleStatusEnum } from '../../../models/enums/operator-vehicle-status.enum';
import { AppDataService, ConfigService, RiderService } from 'app/services';
import { TableLazyLoadEvent } from 'primeng/table';


@Component({
	selector: 'taxi-vehicles',
	templateUrl: './taxi-vehicles.component.html',
	styleUrls: ['./taxi-vehicles.component.scss']
})
export class TaxiVehiclesComponent implements OnInit, OnChanges {
	@Input()
	public menuPermissionActive!: string;

	/** `taxi` — только Taxi; `connex` — Connex + SUV (пул ConneX Vehicles). */
	@Input()
	public vehiclePool: 'taxi' | 'connex' = 'taxi';

	public visibleSidebarRiderVehicleDetail: boolean = false;
	public showVehicleAddSideBar: boolean = false;

	public vehicleToEdit: any = null;

	public isVisibleVehicleDetail: any;
	public selectedVehicle: any;

	public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;
	// Grid settings
	public rowsPerPage: number = 10;
	public totalRecords: number = -1;
	public skip: number = 0;

	public first: number = 0;
	public sortField: string | string[] = '';
	private sortOrder: number = 1;

	public gridRiders: VehiclesOnboarding = new VehiclesOnboarding();
	public breadcrumbs: MenuItem[] = [];

	public pageTitle = 'Taxi Vehicles';

	constructor(private messageService: MessageService,
		private riderService: RiderService, public configService: ConfigService,
		public appData: AppDataService) {}

	ngOnInit(): void {
		this.applyVehiclePoolUi();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['vehiclePool']) {
			this.applyVehiclePoolUi();
		}
	}

	private applyVehiclePoolUi(): void {
		this.pageTitle = this.vehiclePool === 'connex' ? 'ConneX Vehicles' : 'Taxi Vehicles';
		this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: this.pageTitle }];
	}

	/** Поля для GetTaxiVehicles / CreateTaxiVehicle / UpdateTaxiVehicle при пуле Connex. */
	public getVehiclePoolRequestExtras(): { ServiceTypeId?: number; VehicleTypeId?: number } {
		if (this.vehiclePool === 'connex') {
			return { ServiceTypeId: ServiceTypeEnum.Connex, VehicleTypeId: RiderVehicleTypeEnum.SUV };
		}
		return {};
	}

	public riderVehicleId!: number;

	public fieldTypeEnum = FieldTypeEnum;

	private searchTimer: number = 0;
	public riderHeaderSearch: any = {
		id: null,
		year: null,
		brand: null,
		model: null,
		chassisNumber: null,
		status: null,
		numberPlate: null,
		ltfrbCaseNumber: null
	};
	public riderOnboardingDate: Date[] = [];
	public riderVehicleType!: RiderVehicleType[];
	public arrayFilterStatuses: any = [
		{ name: 'Pending', value: OperatorVehicleStatusEnum.Pending },
		{ name: 'Rejected', value: OperatorVehicleStatusEnum.Rejected },
		{ name: 'Approved', value: OperatorVehicleStatusEnum.Approved }
	];

	public arrayFilterRiderServiceAndVehicle: any = [];

	public operatorVehicle: any;

	public cols: any[] = [
		{
			field: 'Id', header: 'Vehicle ID', width: '20%', disableSort: false, fieldType: FieldTypeEnum.InputNumber,
			model: 'id', placeholder: 'Type here'
		},
		{
			field: 'Year', header: 'Year', width: '20%', disableSort: false, fieldType: FieldTypeEnum.InputNumber,
			model: 'year', placeholder: 'Type here'
		},
		{
			field: 'Brand', header: 'Make', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
			model: 'brand', options: this.arrayFilterStatuses, placeholder: 'Please Select'
		},
		{
			field: 'Model', header: 'Car model', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
			model: 'model', placeholder: 'Type here'
		},
		{
			field: 'ChassisNumber', header: 'Chassis Number', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
			model: 'chassisNumber', placeholder: 'Type here'
		},
		{
			field: 'NumberPlate', header: 'Number Plate', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
			model: 'numberPlate', placeholder: 'Type here'
		},
		{
			field: 'LTFRBCaseNumber', header: 'LTFRB Case Number', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
			model: 'ltfrbCaseNumber', placeholder: 'Type here'
		},
		{
			field: 'Status', header: 'Status', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
			model: 'status', placeholder: 'Type Here'
		},
		{
			field: 'Action', header: 'Action', width: '10%', disableSort: true, fieldType: FieldTypeEnum.Inputs,
			model: null, placeholder: ''
		}
	];
	public defaultCols = this.cols.map(x => x);


	public handleLazyLoad(event: TableLazyLoadEvent): void {
		this.skip = event.first ? event.first : 0;

		if (event.rows) {
			this.rowsPerPage = event.rows;
		}

		if (!event.sortField) {
			this.sortField = 'Id';
			this.sortOrder = -1; // Desc
		}
		else {
			this.sortField = event.sortField;
			this.sortOrder = event.sortOrder ? event.sortOrder : 1;
		}

		this.callVehiclePageTitles();
	}

	onSelectedColumnsChange(event: any) {
		if (event && event.length > 0) {
			this.cols = event;
		} else {
			this.cols = this.defaultCols;
		}
	}

	callVehiclePageTitles() {
		this.callRidersVehicleOnboarding();
	}

	public callRidersVehicleOnboarding() {
		this.gridRiders = new VehiclesOnboarding();
		const dto = this.getDto();
		this.gerRidersVehicleOnboarding(dto);
	}

	public getDto() {

		const dto: Record<string, unknown> = {
			Id: this.riderHeaderSearch.id,
			Year: this.riderHeaderSearch.year,
			Brand: this.riderHeaderSearch.brand,
			Model: this.riderHeaderSearch.model,
			ChassisNumber: this.riderHeaderSearch.chassisNumber,
			NumberPlate: this.riderHeaderSearch.numberPlate,
			LTFRBCaseNumber: this.riderHeaderSearch.ltfrbCaseNumber,
			Status: this.riderHeaderSearch.status,
			Take: this.gridRiders.Take,
			Skip: this.skip,
			SortOrder: this.sortOrder,
			SortField: this.sortField,
			...this.getVehiclePoolRequestExtras()
		};
		return dto;
	}

	public gerRidersVehicleOnboarding(dto: any) {
		this.gridRiders.Loading = true;
		this.riderService.getTaxiVehicles(dto, this.messageService).then(data => {
			if (!data.Success) {
				this.gridRiders.Loading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
				return;
			}
			this.totalRecords = data.TotalRecords;
			this.gridRiders.Items = [...data.Vehicles];
			this.gridRiders.Loading = false;
		})
		.catch(err => {
			this.gridRiders.Loading = false;
			throw err;
		});
	}

	public handleHeaderFilterChange(model: string, event: any) {
		if (this.searchTimer) {
			window.clearTimeout(this.searchTimer);
		}
		this.searchTimer = window.setTimeout(() => {
			this.skip = 0;
			this.callVehiclePageTitles();
			this.searchTimer = 0;
		}, 1500);
	}

	public onChangeDateAndDropDown(event: any) {
		this.skip = 0;
		if (event[1]) {
			this.callVehiclePageTitles();
		}
	}

	public onChangeHeaderFilterDropDown(model: string, event: any) {
		if (this.searchTimer) {
			window.clearTimeout(this.searchTimer);
		}

		this.searchTimer = window.setTimeout(() => {
			this.skip = 0;
			this.callVehiclePageTitles();
			this.searchTimer = 0;
		}, 1500);
	}

	public openSidebarExistingVehicleDetail(item: any) {
		this.selectedVehicle = item;
		if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create) ||
			this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Update)) {
			this.operatorVehicle = item;
			this.changedVisibleSidebarRiderVehicleDetailEmit(true);
		}
		else {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
		}
	}

	changedVisibleSidebarRiderVehicleDetailEmit(value: any) {
		this.visibleSidebarRiderVehicleDetail = value;
	}

	public hideVehicleDetailModal(event: boolean): void {
		this.visibleSidebarRiderVehicleDetail = event;
	}

	openDriverAddSideBar() {
		this.vehicleToEdit = null;
		this.showVehicleAddSideBar = true;
	}

	openEditVehicle(vehicle: any) {
		this.vehicleToEdit = vehicle;
		this.isVisibleVehicleDetail = false;
		this.showVehicleAddSideBar = true;
	}

	changedShowTaxiVehicleAddSideBarEmit(value: any) {
		this.showVehicleAddSideBar = value;
		if (!value) {
			this.vehicleToEdit = null;
		}
	}

	changedVisibleTaxiVehicleDetailEmit(value: any) {
		this.isVisibleVehicleDetail = value;
	}

	onVehicleAssignmentChanged(): void {
		const id = this.selectedVehicle?.Id;
		if (id == null) {
			this.callVehiclePageTitles();
			return;
		}
		const dto = { ...this.getDto(), Id: id, Skip: 0, Take: 1 };
		this.riderService.getTaxiVehicles(dto, this.messageService).then(data => {
			if (data?.Success && data.Vehicles?.length) {
				this.selectedVehicle = data.Vehicles[0];
			}
			this.callVehiclePageTitles();
		});
	}

	openVehicleDetails(vehicle: any) {
		if (!vehicle) {
			this.isVisibleVehicleDetail = false;
			this.selectedVehicle = null;
			return;
		}
		this.selectedVehicle = vehicle;
		this.isVisibleVehicleDetail = true;
	}
}
class VehiclesOnboarding {
	public Loading: boolean = true;
	public TotalRecords: number = 0;
	public Items: Array<any> = [];
	public Skip: number = 0;
	public Take: number = 10;
	public VisibleBtnLoadMore: boolean = false;
}
